import { useEffect } from 'react';

const { ItemNotify } = require('../styles');
const { useNotifications } = require('../context');

export const NewsNotifications = () => {
  const { notifications, deleteNotification, toggleReadStatus } = useNotifications();
  useEffect(() => {
    console.log("noti",notifications)
  }, [notifications]);
  return (
    <>
      {notifications.length > 0 ? (
        notifications.sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        ).map((notification) => (
          <ItemNotify key={notification.id}>
            <h3>{notification.title}</h3>
            <p>{notification.body}</p>
            <div className="containerImage">
              {notification.image && <img src={process.env.NEXT_PUBLIC_IMAGE_DOMAIN + notification.image} alt={notification.title} />}
            </div>
            <div className="btn_group">
              <button onClick={() => deleteNotification(notification.id)}>
                Eliminar
              </button>
              {notification.read ? (
                <button onClick={() => toggleReadStatus(notification.id)}>
                  Marcar como no leído
                </button>
              ) : (
                <button onClick={() => toggleReadStatus(notification.id)}>
                  Marcar como leído
                </button>
              )}
            </div>
          </ItemNotify>
        ))
      ) : (
        <div className="no_notify">
          <p>No hay notificaciones</p>
        </div>
      )}
    </>
  );
};

